import { LightPathDTO } from 'business/models/Models';
import { CrystalClientDTO } from 'components/Experiment/constants';

export default class TransformPoints {
  public crWidth: number;
  public crHeight: number;
  public imageWidth: number;
  public imageHeight: number;
  public canvasWidth: number;
  public canvasHeight: number;
  public scalingWidth: number;
  public scalingHeight: number;
  public leftMargin: number;
  public topMargin: number;

  constructor(
    imageWidth: number,
    imageHeight: number,
    crWidth: number,
    crHeight: number,
    canvasWidth: number,
    canvasHeight: number,
  ) {
    this.imageWidth = imageWidth;
    this.imageHeight = imageHeight;
    this.crWidth = crWidth;
    this.crHeight = crHeight;
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;

    this.setAspectRatioParameter();
  }

  setAspectRatioParameter() {
    let aspectRatio = this.imageWidth / this.imageHeight;
    this.scalingHeight = this.crHeight;
    this.scalingWidth = this.scalingHeight * aspectRatio;

    aspectRatio = this.scalingWidth / this.scalingHeight;
    this.scalingHeight = this.canvasHeight;
    this.scalingWidth = this.scalingHeight * aspectRatio;
    if (this.scalingWidth > this.canvasWidth) {
      this.scalingWidth = this.canvasWidth;
      this.scalingHeight = this.scalingWidth / aspectRatio;
    }
    this.leftMargin = (this.canvasWidth - this.scalingWidth) / 2;
    this.topMargin = (this.canvasHeight - this.scalingHeight) / 2;
  }

  FromDbToCanvas(x: number, y: number) {
    const xDash = this.XTransformToCanvas(x);
    const yDash = this.YTransformToCanvas(y);
    return [xDash, yDash];
  }

  FromCanvasToDb(xDash: number, yDash: number) {
    const x = this.XTransformFromCanvas(xDash);
    const y = this.YTransformFromCanvas(yDash);
    return [x, y];
  }

  XTransformToCanvas(point: number) {
    let x = point + this.crWidth / 2;
    x = (x / this.crWidth) * this.scalingWidth + this.leftMargin;
    return x;
  }

  YTransformToCanvas(point: number) {
    let y = (point - this.crHeight / 2) * -1;
    y = (y / this.crHeight) * this.scalingHeight + this.topMargin;
    return y;
  }

  XTransformFromCanvas(point: number) {
    let x = ((point - this.leftMargin) / this.scalingWidth) * this.crWidth;
    x = x - this.crWidth / 2;
    return x;
  }

  YTransformFromCanvas(point: number) {
    let y = ((point - this.topMargin) / this.scalingHeight) * this.crHeight;
    y = this.crHeight / 2 - y;
    return y;
  }
  convertSizeToDB(width: number, height: number) {
    return [
      (width * this.scalingWidth) / this.crWidth,
      (height * this.scalingHeight) / this.crHeight,
    ];
  }
  ConvertSizeToCanvas(width: number, height: number) {
    return [
      (width * this.crWidth) / this.scalingWidth,
      (height * this.crHeight) / this.scalingHeight,
    ];
  }
  convertDrawingDimensions(points: any) {
    const newWidth = (points.width * this.crWidth) / this.scalingWidth;
    const newHeight = (points.height * this.crHeight) / this.scalingHeight;

    let xOffset =
      ((points.x - this.leftMargin) * this.crWidth) / this.scalingWidth -
      this.crWidth / 2;
    xOffset = xOffset + newWidth / 2;
    let yOffset = ((points.y - this.topMargin) * this.crHeight) / this.scalingHeight;
    yOffset = this.crHeight / 2 - yOffset - newHeight / 2;

    const drawingPoints = [];
    drawingPoints.push(xOffset);
    drawingPoints.push(yOffset);
    drawingPoints.push(newWidth);
    drawingPoints.push(newHeight);
    return drawingPoints;
  }

  ConvertROIToCanvas(roi: any) {
    let xCenter = this.crWidth / 2 - (roi.xWidth / 2 - roi.xCenterOffSet);
    xCenter = (xCenter / this.crWidth) * this.scalingWidth + this.leftMargin;

    let yCenter = this.crHeight / 2 - roi.yCenterOffSet - roi.yHeight / 2;
    yCenter = (yCenter / this.crHeight) * this.scalingHeight + this.topMargin;

    const width = (roi.xWidth / this.crWidth) * this.scalingWidth;
    const height = (roi.yHeight / this.crHeight) * this.scalingHeight;

    return { xCenter, yCenter, width, height };
  }

  ConvertCrystalToCanvas(crystal: CrystalClientDTO) {
    let xCenter = this.crWidth / 2 - (crystal.width / 2 - crystal.x);
    xCenter = (xCenter / this.crWidth) * this.scalingWidth + this.leftMargin;

    let yCenter = this.crHeight / 2 - crystal.y - crystal.height / 2;
    yCenter = (yCenter / this.crHeight) * this.scalingHeight + this.topMargin;

    const width = (crystal.width / this.crWidth) * this.scalingWidth;
    const height = (crystal.height / this.crHeight) * this.scalingHeight;

    return { xCenter, yCenter, width, height };
  }

  ConvertLightPathToCanvas(lightPath: LightPathDTO) {
    const xCenterLP =
      this.crWidth / 2 - (lightPath.rectangleF.width / 2 - lightPath.rectangleF.x);
    lightPath.rectangleF.x =
      (xCenterLP / this.crWidth) * this.scalingWidth + this.leftMargin;

    const yCenterLP =
      this.crHeight / 2 - lightPath.rectangleF.y - lightPath.rectangleF.height / 2;
    lightPath.rectangleF.y =
      (yCenterLP / this.crHeight) * this.scalingHeight + this.topMargin;

    lightPath.rectangleF.width =
      (lightPath.rectangleF.width / this.crWidth) * this.scalingWidth;
    lightPath.rectangleF.height =
      (lightPath.rectangleF.height / this.crHeight) * this.scalingHeight;

    lightPath.minFOVSize.width =
      (lightPath.minFOVSize.width / this.crWidth) * this.scalingWidth;
    lightPath.minFOVSize.height =
      (lightPath.minFOVSize.height / this.crHeight) * this.scalingHeight;

    lightPath.maxFOVSize.width =
      (lightPath.maxFOVSize.width / this.crWidth) * this.scalingWidth;
    lightPath.maxFOVSize.height =
      (lightPath.maxFOVSize.height / this.crHeight) * this.scalingHeight;
    lightPath.validSizeList = lightPath.validSizeList?.map((size) => {
      size.width = (size.width / this.crWidth) * this.scalingWidth;
      size.height = (size.height / this.crHeight) * this.scalingHeight;
      return size;
    });

    return lightPath;
  }

  ConvertPointsToROI(roi: any) {
    const width = (roi.xWidth * this.crWidth) / this.scalingWidth;
    const height = (roi.yHeight * this.crHeight) / this.scalingHeight;

    return { width, height };
  }

  ConvertPointsToCrystal(crystal: any) {
    const width = (crystal.width * this.crWidth) / this.scalingWidth;
    const height = (crystal.height * this.crHeight) / this.scalingHeight;

    return { width, height };
  }

  calculateEuclideanDistance(x1: number, y1: number, x2: number, y2: number) {
    const p1Sq = Math.pow(x1 - x2, 2);
    const p2Sq = Math.pow(y1 - y2, 2);
    const eDistance = Math.sqrt(p1Sq + p2Sq);
    return Math.round(eDistance * 1000) / 1000;
  }

  calculateCanvasEuclideanDistance(x1: number, y1: number, x2: number, y2: number) {
    const [px1, py1] = this.FromCanvasToDb(x1, y1);
    const [px2, py2] = this.FromCanvasToDb(x2, y2);
    return this.calculateEuclideanDistance(px1, py1, px2, py2);
  }
  getCRWidthHeight() {
    return { crWidth: this.crWidth, crHeight: this.crHeight };
  }

  ConvertRectanglePointsToCanvas(x, y, w, h) {
    let xCenter = this.crWidth / 2 - (w / 2 - x);
    xCenter = (xCenter / this.crWidth) * this.scalingWidth + this.leftMargin;

    let yCenter = this.crHeight / 2 - y - h / 2;
    yCenter = (yCenter / this.crHeight) * this.scalingHeight + this.topMargin;

    const width = (w / this.crWidth) * this.scalingWidth;
    const height = (h / this.crHeight) * this.scalingHeight;

    return { xCenter, yCenter, width, height };
  }

  convertRectangleDrawingForDb(x: number, y: number, width: number, height: number) {
    const newWidth = (width * this.crWidth) / this.scalingWidth;
    const newHeight = (height * this.crHeight) / this.scalingHeight;

    let xOffset =
      ((x - this.leftMargin) * this.crWidth) / this.scalingWidth - this.crWidth / 2;
    xOffset = xOffset + newWidth / 2;
    let yOffset = ((y - this.topMargin) * this.crHeight) / this.scalingHeight;
    yOffset = this.crHeight / 2 - yOffset - newHeight / 2;
    return { x: xOffset, y: yOffset, width: newWidth, height: newHeight };
  }
}
